import * as UserActions from './user';
import * as PayActions from './pay';
import * as tradeActions from './trade';
import * as homeActions from './home';

export default {
  ...UserActions,
  ...PayActions,
  ...tradeActions,
  ...homeActions
};
